import type { FC } from "react";
import { useParams } from "react-router-dom";
import { OrganizationDetailPage } from "./OrganizationDetailPage";

const OrganizationDetailContainer: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Invalid organization ID</div>;
  }

  return <OrganizationDetailPage />;
};

export default OrganizationDetailContainer;
